import { render, staticRenderFns } from "./newSchemeDetailsTableImgReport.vue?vue&type=template&id=627def93"
import script from "./newSchemeDetailsTableImgReport.vue?vue&type=script&lang=js"
export * from "./newSchemeDetailsTableImgReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports